import { formatMokaPointCount } from "@/utils/format-moka-point-count";
import { getMokaAreaScore } from "@/utils/get-moka-area-score";
const getMokaMatchResultMessage = gameState => {
  const score = getMokaAreaScore(gameState);
  if (score > 0) {
    return `You win by ${formatMokaPointCount(score)}.`;
  }
  if (score < 0) {
    return `Moka wins by ${formatMokaPointCount(Math.abs(score))}.`;
  }
  return "The game is a draw.";
};
export { getMokaMatchResultMessage };